<template>
  <div>
    <p>
      Enviamos um código de 6 dígitos para <strong>{{ email }}</strong
      >. Digite-o abaixo para concluir a pré-matrícula.
    </p>
    <v-alert type="info" outlined dense>
      Não encontrou o e-mail? Confira a caixa de <strong>spam</strong> ou lixo eletrônico.
    </v-alert>

    <p v-if="segundosParaExpirar > 0" aria-live="polite">
      O código vale por {{ validadeEmMinutos }} minutos. Expira em
      <strong>{{ formatarTempo(segundosParaExpirar) }}</strong
      >.
    </p>
    <v-alert v-else type="warning" outlined dense>
      O código expirou. Solicite um novo código.
    </v-alert>

    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(() => $emit('confirmar', codigo))">
        <ValidationProvider name="Código" rules="required|digits:6" v-slot="{ errors }">
          <e-label>Código de confirmação</e-label>
          <v-text-field
            v-model="codigo"
            v-mask="'######'"
            inputmode="numeric"
            autocomplete="one-time-code"
            :error-messages="errors"
            dense
            solo
          />
        </ValidationProvider>

        <v-alert v-if="erro" type="error" outlined role="alert">{{ erro }}</v-alert>

        <v-btn block color="primary" type="submit" :loading="confirmando" :disabled="confirmando">
          Confirmar e gerar boleto
        </v-btn>
      </v-form>
    </ValidationObserver>

    <div class="d-flex flex-wrap justify-space-between mt-3">
      <v-btn text :disabled="confirmando" @click="$emit('voltar')">Corrigir dados</v-btn>
      <v-btn
        text
        color="primary"
        :disabled="segundosParaReenvio > 0 || enviando || confirmando"
        :loading="enviando"
        @click="$emit('reenviar')"
      >
        {{
          segundosParaReenvio > 0 ? `Reenviar código em ${segundosParaReenvio}s` : "Reenviar código"
        }}
      </v-btn>
    </div>
  </div>
</template>

<script>
// A API só aceita novo envio depois de 1 minuto do anterior.
const INTERVALO_DE_REENVIO_EM_SEGUNDOS = 60;

export default {
  name: "ECodigoDeConfirmacao",
  props: {
    email: { type: String, required: true },
    enviadoEm: { type: Number, required: true },
    validadeEmMinutos: { type: Number, default: 5 },
    enviando: { type: Boolean, default: false },
    confirmando: { type: Boolean, default: false },
    erro: { type: String, default: null },
  },
  data() {
    return { codigo: "", agora: Date.now(), relogio: null };
  },
  computed: {
    segundosDesdeOEnvio() {
      return Math.floor((this.agora - this.enviadoEm) / 1000);
    },
    segundosParaReenvio() {
      return Math.max(0, INTERVALO_DE_REENVIO_EM_SEGUNDOS - this.segundosDesdeOEnvio);
    },
    segundosParaExpirar() {
      return Math.max(0, this.validadeEmMinutos * 60 - this.segundosDesdeOEnvio);
    },
  },
  mounted() {
    this.relogio = setInterval(() => {
      this.agora = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.relogio);
  },
  methods: {
    formatarTempo(segundos) {
      const minutos = Math.floor(segundos / 60);
      return `${minutos}:${String(segundos % 60).padStart(2, "0")}`;
    },
  },
};
</script>
